<div class="content">
    <div class="row items-push">
      <div class="col-sm-12 text-left">
        <ol class="breadcrumb push-10-t">
          <li><a href="">Configuracion</a></li>
          <li>
            <a
              class="link-effect"
              [routerLink]="['/configuracion', 'documentos']"
              >Documentos</a
            >
          </li>
          <li><span class="link-effect">Editar</span></li>
        </ol>
      </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Editar Documento</h3>
      </div>
      <div class="block-content">
        <div class="form-horizontal">
          <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

          
          <div class="form-group">
              <label class="col-md-2 control-label">Documento:</label>
              <div class="col-md-3">
                <!-- <mat-form-field appearance="outline">
                  <mat-label>Documento</mat-label>
                  <input matInput type="text" [(ngModel)]="model.documentoRequerido" name="nombre" maxlength="50" required />
                </mat-form-field> -->
                <mat-form-field appearance="outline">
                  <mat-label> Seleccione: </mat-label>
                  <mat-select matSelect [(ngModel)]="model.idMaestroDocumento" name="idMaestroDocumento">
                    <mat-option 
                      *ngFor="let item of listaMaestroDocumentos; index as i"
                      [value]="item.idMaestroDocumento"
                    >{{ item.documento }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <label class="col-md-2 control-label">Sección:</label>
              <div class="col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label> Seleccione: </mat-label>
                  <mat-select matSelect [(ngModel)]="model.seccion" name="seccion">
                    <mat-option [value]="1">PERSONAL</mat-option>
                    <mat-option [value]="2">EQUIPOS</mat-option>
                    <mat-option [value]="3">VEHICULOS</mat-option>
                    <mat-option [value]="4">DOCUMENTACION TECNICA</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
          </div>

          <div class="form-group">
            <label class="col-md-2 control-label">Restringe Accesos:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline" >
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.restringeAccesos" name="restringeAccesos" (selectionChange)="changeRestringeAccessos($event)">
                  <mat-option [value]="true">Si</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <label class="col-md-2 control-label">Requisito:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.idRequisito" name="idRequisito" [disabled]="model.restringeAccesos">
                  <mat-option 
                    *ngFor="let item of listaTipoRequisitos; index as i"
                    [value]="item.idParametroDetalle"
                  >{{ item.valor }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
          </div>

          <div class="form-group">
            <label class="col-md-2 control-label">Controlar Fechas:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.controlarFechas" name="controlarFechas" [disabled]="model.restringeAccesos">
                  <mat-option [value]="true">Si</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
            <label class="col-md-2 control-label">Predeterminado:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.esPredeterminado" name="esPredeterminado" [disabled]="model.restringeAccesos">
                  <mat-option [value]="true">Si</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <label class="col-md-2 control-label">Tipo Visita:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.idTipoVisita" name="idTipoVisita" >
                  <mat-option 
                      *ngFor="let item of listaTipoVisitas; index as i"
                      [value]="item.idTipoVisita"
                    >{{ item.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
            <label class="col-md-2 control-label">Estado:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.idEstado" name="idEstado" >
                  <mat-option 
                    *ngFor="let item of listaEstados; index as i"
                    [value]="item.idParametroDetalle"
                  >{{ item.valor }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
              <div class="col-sm-12">
                <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-raised-button >Guardar</button>
                <a class="btn btn-naranja2" mat-raised-button [routerLink]="['/configuracion/documentos']" >Cancelar</a>              
              </div>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div>  